import { Component, Input } from '@angular/core';

@Component({
  selector: 'affinis-input-group',
  standalone: true,
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.scss'],
})
export class AffinisInputGroupComponent {
  @Input() prefix = '';

  @Input() suffix = '';
}
